import { useContext } from "react";
import { useTranslation as useInner } from "react-i18next";
import { QuizContext } from "../providers/QuizProvider/QuizContext";

export const useTranslation = () => {
  const { language_code } = useContext(QuizContext);
  return useInner("playerNs", { lng: language_code });
};
